export default function AboutSection() {
  return (
    <section id="about" className="py-14 md:py-20 bg-background-100">
      <div className="w-full px-4 md:px-6">
        <div className="max-w-7xl mx-auto">
          <div className="text-center mb-8">
            <h2 className="font-heading text-2xl md:text-3xl font-bold text-foreground-950">关于片多多影视</h2>
            <p className="mt-3 text-sm text-foreground-500 max-w-2xl mx-auto">
              打造免费高清影视新体验
            </p>
          </div>
          <div className="max-w-3xl mx-auto">
            <div className="bg-background-50 rounded-2xl p-6 md:p-10">
              <p className="text-sm md:text-base text-foreground-600 leading-relaxed">
                片多多影视是专注于高清免费影视资源聚合的平台，致力于为广大影视爱好者提供片多多高清免费、片多多免费观看的优质体验。我们汇集了全网最新的电影、热播电视剧、综艺娱乐、动漫番剧以及经典纪录片等海量内容。平台采用先进的视频加速技术，确保片多多高清不卡，无论何时何地都能享受超清流畅的在线观影体验。
              </p>
              <p className="mt-4 text-sm md:text-base text-foreground-600 leading-relaxed">
                片多多影视坚持完全免费运营，无需注册付费即可观看全部内容。我们每日更新片库，紧跟热门播出节奏，让您第一时间看到想看的影视内容。从院线大片到经典老片，从古装玄幻到都市情感，片多多影视全方位覆盖您的观影需求。
              </p>
              <div className="mt-6 flex flex-wrap gap-4">
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-primary-100 text-primary-700 text-xs font-medium">
                  <i className="ri-check-line"></i> 完全免费
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-accent-100 text-accent-700 text-xs font-medium">
                  <i className="ri-check-line"></i> 高清画质
                </span>
                <span className="inline-flex items-center gap-1.5 px-3 py-1.5 rounded-full bg-secondary-100 text-secondary-700 text-xs font-medium">
                  <i className="ri-check-line"></i> 流畅不卡
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}